/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { MouseEvent, CSSProperties, ReactNode } from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Button } from '@material-ui/core';
import { ColorList } from '@/components/Interface';

interface ButtonProps {
  onClick?: (event: MouseEvent) => void;
  loading?: boolean;
  color?: ColorList;
  style?: CSSProperties;
  children?: ReactNode;
  href?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  colorClass?: string;
  borderRadius?: string;
  disabled?: boolean;
  btnTestId?: string;
  variant?: 'text' | 'outlined' | 'contained';
}

const useStyles = makeStyles(theme => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const ContainedButtons = (props: ButtonProps) => {
  const {
    children,
    color = ColorList.PRIMARY,
    href,
    fullWidth = true,
    size = 'medium',
    style,
    onClick,
    className,
    colorClass = 'lifepack-button-white',
    loading,
    borderRadius = '5px',
    disabled = false,
    btnTestId,
    variant = 'contained',
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const createdStyle: any = {
    borderRadius,
    ...style,
  };

  const classes = useStyles();

  return (
    <>
      {/* to access Button element on test, use .nextSibling */}
      <div data-testid={btnTestId} onClick={loading ? () => null : onClick} />
      <Button
        variant={variant}
        style={createdStyle}
        className={
          variant !== 'text'
            ? classnames('themed-button', classes.submit, className, colorClass)
            : undefined
        }
        fullWidth={fullWidth}
        href={href}
        size={size}
        onClick={loading ? () => null : onClick}
        disabled={disabled}
      >
        {loading ? <CircularProgress size={14} color="primary" /> : children}
      </Button>
    </>
  );
};

export default ContainedButtons;
